document.addEventListener( 'DOMContentLoaded', function () {

    const is_product_page = document.body.classList.contains( 'single-product' );
    if( !is_product_page ){
        return;
    }
    
    // Product is given via PHP
    let pa_pricing = product.pa_pricing;
    let pa_packcontent = 1;

    if( pa_pricing == "Pakprijs"){
        pa_packcontent = parseFloat( product.pa_packcontent.replace( /,/g, '.' ) );
    }

    // Prevents keys to be pressed on the quantity field
    document.getElementById( 'quantity' ).addEventListener( 'keydown', function ( e ) {
        if (
            (e.key === '.' || e.keyCode === 190) ||
            (e.key === '+' || e.keyCode === 107) ||
            (e.key === '-' || e.keyCode === 109) ||
            (e.key === 'e' || e.keyCode === 69) ||
            (e.key === 'ArrowUp' || e.keyCode === 38) ||
            (e.key === 'ArrowDown' || e.keyCode === 39)
        ) {
            e.preventDefault(); // Prevent the default action (typing the period)
        }
    } );

    // Disable pasting of anything
    document.getElementById( 'quantity' ).addEventListener( 'paste', function ( e ) {
        e.preventDefault(); // Prevent the paste action
    } );

    // Edit the field after deselect or delay
    document.getElementById( 'quantity' ).addEventListener( 'input', function () {
        clearTimeout(this.delayTimer);
        const input = this;
        var hidden_input = document.querySelector( '#quantity_hidden' );

        this.delayTimer = setTimeout( function () {
            // The input of the client
            const quantity = parseFloat( input.value );

            // Calculate the amount of packages that should be delivered
            const packages = Math.ceil( quantity / pa_packcontent );

            // Recalculate the amount m² that shall be delivered based on the amount of packages
            let recalculated_m2 = packages * pa_packcontent;
            
            // Determine the number of decimal places to show
            let recalculated_m2_str = recalculated_m2.toFixed( 3 ); // Convert to string with up to 3 decimal places
            // When it ends with a 0, round to 2 decimals
            if ( recalculated_m2_str.endsWith( '0' ) ) {
                // If the last decimal is 0, show only 2 decimals
                recalculated_m2_str = recalculated_m2.toFixed( 2 );
            }

            // Update the hidden input field with recalculated m²
            hidden_input.value = recalculated_m2_str; 
            
            // Update the label to show the number of packages
            if( process.env.COMPONENT_PRODUCT_OPTIONS__SHOW_PACKAGE && pa_pricing == "Pakprijs" ) {
                var label = document.querySelector( 'label.unit' );
                if ( packages > 0 ) {
                    label.textContent = `m² (${packages} pak${packages > 1 ? 'ken' : ''})`;
                } else {
                    label.textContent = 'm² (1 pak)';
                }
            }
        }, 10 ); // Delay in milliseconds of updating after input change
    } );
} );